/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

import createBrowserHistory from 'history/lib/createBrowserHistory';
import createRouterHistory from './createRouterHistory';
export default createRouterHistory(createBrowserHistory);



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-router/es6/browserHistory.js
// module id = 882
// module chunks = 76